/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Publizon Library API
 * Pubhub exists in two separate environments, each with their own server, code and database. Please use the web service located at library-api.qa.pubhub.dk when developing and testing.
Orders/loans created in test environment will not be invoiced. Please request a new license key for the production environment when you're ready to go live.
 * OpenAPI spec version: 1
 */

export type FileExtensionType =
  (typeof FileExtensionType)[keyof typeof FileExtensionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileExtensionType = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4
} as const;
